import React from 'react'
import Form from 'react-bootstrap/Form';

import { Roles } from '../../../api/types';
import Table, {
  ActionPopover,
  ActionPopoverButton,
} from '../../../components/Table';

import RoleDropdown from './RoleDropdown';


export interface ShareUser {
  eMail: string
  name?: string
  userId?: string 
  role: Roles
}

export interface ShareUsers {
  [key: string]: ShareUser
}

interface UserTableProps {
  users: ShareUsers
  disabled: boolean
  onUpdate: (
    email: string,
    role: Roles
  ) => void
  onDelete: (
    email: string
  ) => void
}

const UserTable = ( props: UserTableProps ) => {
  const columnData = [
    {
      Header: '',
      accessor: 'icon',
      width: 70,
      sortable: false
    },
    {
      Header: 'Email',
      accessor: 'eMail',
    },
    {
      Header: 'Role',
      accessor: 'role',
      sortable: false,
    },
    {
      Header: '',
      accessor: 'action',
      width: 70,
      sortable: false,
    }
  ];

  const rowData = Object.keys(props.users).map(k => {
    const onDelete = () => props.onDelete(props.users[k].eMail);
    const onUpdate = ( role: Roles ) => props.onUpdate(props.users[k].eMail, role);

    return {
      icon: <span className='d-flex justify-content-center'><i className="modus-icons">user</i></span>,
      eMail: props.users[k].eMail,
      role: (
        <RoleDropdown
          role={props.users[k].role}
          setRole={onUpdate}
          disabled={props.disabled}
        />
      ),
      action: (
        <ActionPopover>
          <ActionPopoverButton
            variant='danger'
            onClick={onDelete}
            disabled={props.disabled
              || props.users[k].role === 'Owner'}
          >
            <span>Delete</span>
          </ActionPopoverButton>
        </ActionPopover>
      )
    }
  });

  return rowData.length > 0 ? (
    <Form.Group>
      <Form.Label>Added Users</Form.Label>
      <Table
        columns={columnData}
        data={rowData}
      />
    </Form.Group>
  ) : null
}


export default UserTable;
